import CryptoJS from "crypto-js";

export const GUEST_ID_KEY = "gx_92kQ";
export const GUEST_CART_KEY = "cRt_7dP1";
export const CART_SYNC_KEY = "sYnC_4LrX";
export const CART_HASH_KEY = "cRt_hash";

const SECRET = "cRt_!@#_local"; // local-only hash salt, not sensitive

const validateCartItem = (item) => {
    if (!item || typeof item !== "object") return false;

    const hasValidId = typeof item._id === "string" && item._id.trim() !== "";
    const hasValidSplitBuyId = typeof item.split_buy_id === "string" && item.split_buy_id.trim() !== "";
    const hasValidPrice = typeof item.price === "number" && item.price >= 0;
    const hasValidAvailableSlots = typeof item.available_slots === "number" && item.available_slots >= 0;

    return hasValidId && hasValidSplitBuyId && hasValidPrice && hasValidAvailableSlots;
};

const computeHash = (data) => CryptoJS.SHA256(JSON.stringify(data) + SECRET).toString();

export const CartStorageUtil = {
    getGuestId() {
        return localStorage.getItem(GUEST_ID_KEY);
    },

    setGuestId(id) {
        localStorage.setItem(GUEST_ID_KEY, id);
    },

    getGuestCart() {
        try {
            const stored = localStorage.getItem(GUEST_CART_KEY);
            const hash = localStorage.getItem(CART_HASH_KEY);
            if (!stored) return [];

            const parsed = JSON.parse(stored);
            if (!Array.isArray(parsed)) return [];

            const valid = computeHash(parsed) === hash;
            if (!valid) {
                this.clearGuestCart();
                return [];
            }
            return parsed.filter(validateCartItem);
        } catch {
            return [];
        }
    },

    setGuestCart(cart) {
        const cleanCart = cart.filter(validateCartItem);
        const json = JSON.stringify(cleanCart);
        localStorage.setItem(GUEST_CART_KEY, json);
        localStorage.setItem(CART_HASH_KEY, computeHash(cleanCart));
    },

    clearGuestCart() {
        localStorage.removeItem(GUEST_CART_KEY);
        localStorage.removeItem(CART_HASH_KEY);
    },

    clearGuestId() {
        localStorage.removeItem(GUEST_ID_KEY);
    },

    // Sync timestamp utilities
    setLastSynced() {
        localStorage.setItem(CART_SYNC_KEY, Date.now().toString());
    }, getLastSynced() {
        return Number(localStorage.getItem(CART_SYNC_KEY)) || 0;
    }, clearLastSynced() {
        localStorage.removeItem(CART_SYNC_KEY);
    }, mapCartItem(item) {
        const splitBuy = item?.split_buy;
        const cartItemId = item?._id;
        const splitBuyId = splitBuy?._id;

        return {
            _id: cartItemId,
            split_buy_id: splitBuyId,
            split_buy_slug: splitBuy?.slug,
            image: splitBuy?.product?.picture_urls?.[0] || "",
            title: splitBuy?.product?.title || "Unknown Product",
            location: splitBuy?.split_buy_product_location?.string || splitBuy?.choice_of_delivery_locations?.[0] || "Location not specified",
            delivery_date: splitBuy?.delivery_date || splitBuy?.join_period_end_date,
            price: splitBuy?.split_cost_per_slot || 0,
            available_slots: (splitBuy?.number_of_buy_ins_required || 0) - (splitBuy?.number_of_buy_ins_attained || 0),
            slot: item?.slot || 1,
            number_of_buy_ins_attained:	splitBuy?.number_of_buy_ins_attained || 0,
            join_period_end_date: splitBuy?.join_period_end_date || null,
        };
    }, normalizeCartResponse(items) {
        return items.map(item => CartStorageUtil.mapCartItem(item));
    },

    normalizeCartItem(item) {
        return CartStorageUtil.mapCartItem(item);
    }

};
